import { gql } from '@apollo/client';

export const GET_MYFORM_SUMMARY = gql`
  query GetMyFormSummary($input: GetMyFormInput!) {
    myForm: getMyForm(input: $input) {
      id
      name
      monitoringForm {
        id
        name
        ownerOrg {
          id
        }
        period {
          id
          name
        }
        formReporters {
          id
        }
        dueDates {
          id
          date
          periodNumber
        }
        indicators {
          id
          dimensions
          indicator {
            id
            period {
              id
            }
            periods {
              id
              periodDate
            }
          }
        }
      }
      workspaceForm {
        id
        name
        description
        version
        published
        hasUnsubmittedSubmissions
        template {
          id
          updatedAt
        }
        dueDates {
          id
          date
          periodDate
        }
      }
    }
  }
`;
